export enum ProductSubCategoryEnum {
  FISH_EYE = 'Fish Eye',
  WIDE_ANGLE = 'Grandangolo',
  STANDARD = 'Standard',
  TELEPHOTO = 'Teleobiettivo',
  SUPER_TELEPHOTO = 'Super tele',
  SUPERZOOM = 'Superzoom',
}
